export enum FunctionId {
    NOVELTY_CHECK = 'rd_novelty_check'
}
